(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hv-eu-withdrawal"]) return;
  try {
    
class HVEUWithdrawal extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const step1 = this.querySelector('[data-ew-step="1"]');
    const step2 = this.querySelector('[data-ew-step="2"]');
    const start = this.querySelector('[data-ew-start]');
    if (!step1 || !step2 || !start) return;
    // Without JavaScript the native form remains visible and usable.
    const hasErrors = step2.hasAttribute('data-ew-errors');
    step1.hidden = hasErrors;
    step2.hidden = !hasErrors;
    start.addEventListener('click', () => {
      step1.hidden = true;
      step2.hidden = false;
      step2.querySelector('input')?.focus();
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('hv-eu-withdrawal')) customElements.define('hv-eu-withdrawal', HVEUWithdrawal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
